import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74f9169e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Palavra Quadrada ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!

  return (_openBlock(), _createBlock(_component_q_toolbar, { class: "bg-black text-white toolbar" }, {
    default: _withCtx(() => [
      _createVNode(_component_q_toolbar_title, null, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_q_btn, {
        flat: "",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onChartPressed')))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_icon, { name: "bar_chart" })
        ]),
        _: 1
      }),
      _createVNode(_component_q_btn, {
        flat: "",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('onHelpPressed')))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_icon, { name: "help" })
        ]),
        _: 1
      }),
      _createVNode(_component_q_btn, {
        flat: "",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('onSettingsPressed')))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_icon, { name: "settings" })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}